import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64878d29"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ant-dropdown-link",
  style: {"margin-right":"30px"}
}
const _hoisted_2 = {
  title: "当前登录角色",
  style: {"display":"inline-block","color":"#2f2f2f"}
}
const _hoisted_3 = ["onClick"]

import {logout} from "@/api/user";
import {watch, reactive, onMounted} from "vue";
// import {removeItem} from '@/components/js/localStorage';
import {SessionStorageService, LocalStorageService} from "@/components/ts/localStorage";
import {useRoute, useRouter} from "vue-router";
import {USER_INFO} from "@/store/mutation-types";
import {groupDentistReviewStatus} from "@/api/doctor";
import STATUS from "@/components/model/enum";


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    collapsed: Boolean,
},
  emits: ["toggle-collapsed"],
  setup(__props, { emit: emits }) {



const toggleCollapsed = () => {
    emits("toggle-collapsed");
};
const route = useRoute();
const router = useRouter();

const state = reactive({
    matched: route.matched,
    visible: false,
    userName: LocalStorageService.get(USER_INFO).name,
    hasNone: 0
});
const jumped = (path: any) => {
    router.push({
        path: path,
    });
};

const handleMenuClick = (e: { key: string; }) => {
    if (e.key === "1") {
        let sts = LocalStorageService.get('sts');
        let url = `${sts.path}downloads/DentalCAD.msi`
        window.location.href = url
    } else if (e.key === "3") {
        state.visible = false;
        logout().then(() => {
            // clearAll('TOKEN')
            LocalStorageService.clearAll();
            SessionStorageService.clearAll();
            router.push({
                path: '/login',
            });
        })
    }
};
const searchByReviewStatus = () => {
    groupDentistReviewStatus().then((res: any) => {
        state.hasNone = res.hasNone
    })
}
// const toDentistTeam = () =>{
//     router.push("/dentistTeamHome")
// }
onMounted(() => {
    searchByReviewStatus();
})
watch(
    () => route,
    (route) => {
        state.matched = route.matched;
    },
    {
        immediate: true,
        deep: true,
    }
);

return (_ctx: any,_cache: any) => {
  const _component_menu_unfold_outlined = _resolveComponent("menu-unfold-outlined")!
  const _component_menu_fold_outlined = _resolveComponent("menu-fold-outlined")!
  const _component_EnvironmentOutlined = _resolveComponent("EnvironmentOutlined")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout_header, { class: "herader" }, {
      default: _withCtx(() => [
        (__props.collapsed)
          ? (_openBlock(), _createBlock(_component_menu_unfold_outlined, {
              key: 0,
              class: "trigger",
              onClick: toggleCollapsed
            }))
          : (_openBlock(), _createBlock(_component_menu_fold_outlined, {
              key: 1,
              class: "trigger",
              onClick: toggleCollapsed
            })),
        _createElementVNode("div", null, [
          _createElementVNode("a", _hoisted_1, [
            _createVNode(_component_a_avatar, {
              size: "small",
              style: { position: 'relative', top: '-2px' }
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_EnvironmentOutlined)
              ]),
              _: 1
            }),
            _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(STATUS)("userType").getDesc(_unref(LocalStorageService).get('AUTH_ROLE'))), 1)
          ]),
          _createVNode(_component_a_dropdown, {
            visible: state.visible,
            "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((state.visible) = $event))
          }, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, { onClick: handleMenuClick }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, { key: "1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 软件下载 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { key: "3" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 退出 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("a", {
                class: "ant-dropdown-link",
                onClick: _cache[0] || (_cache[0] = e => e.preventDefault())
              }, [
                _createVNode(_component_a_avatar, {
                  size: "small",
                  style: { position: 'relative', top: '-2px' }
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_UserOutlined)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(state.userName) + " ", 1),
                _createVNode(_component_DownOutlined)
              ])
            ]),
            _: 1
          }, 8, ["visible"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_breadcrumb, { style: {"margin":"10px","display":"flex"} }, {
      default: _withCtx(() => [
        (state.matched.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.matched, (item) => {
              return (_openBlock(), _createBlock(_component_a_breadcrumb_item, {
                key: item.path
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: ($event: any) => (jumped(item.path))
                  }, _toDisplayString(item.meta.title), 9, _hoisted_3)
                ]),
                _: 2
              }, 1024))
            }), 128))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})